export const getPCFSaveLoadingLabel = (isUpdating: boolean): string =>
  isUpdating ? 'Updating…' : 'Saving…';

export const getPCFSaveDraftLabel = (
  isSaving: boolean,
  isUpdating: boolean
): string => {
  if (!isSaving) {
    return 'Save Draft';
  }

  return getPCFSaveLoadingLabel(isUpdating);
};

export const getPCFActionLabel = (
  defaultLabel: string,
  isSaving: boolean,
  isUpdating: boolean
): string => {
  if (!isSaving) {
    return defaultLabel;
  }

  return getPCFSaveLoadingLabel(isUpdating);
};
